<div class="dialog-container" id="submit-modal">
  <img alt="" src="/assets/images/logo.svg" />
  <div class="vtz-modal-content decline-modal">
    <h1 mat-dialog-title i18n id = "title"
     >Decline to vote?</h1>        
    <mat-dialog-content id="description" i18n>You have selected "Decline to Vote". If you select "Confirm" you will not be able to vote this ballot at a later time. Select "Back" if you want to return to the ballot and vote.</mat-dialog-content>
  </div>
  <mat-dialog-actions >
    <div class="dialog-button-container">
      <button autofocus  id="cancel-button" i18n class="button-secondary button-narrow-screen" mat-dialog-close>BACK</button>
      <div class="vtz-spacer-10"></div>
      <button id="submit-button" i18n class="button-primary button-narrow-screen"
      (click)="submit()">CONFIRM</button>
    </div>
  </mat-dialog-actions>
  @if(displayProgressSpinner){
    <div class="progressSpinner" >
      <mat-spinner [diameter]="300" color="primary" ></mat-spinner>
      <div class="spinner-warning">
        <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
      </div>
    </div> 
  }
</div>  